import { render, staticRenderFns } from "./AdminCompany.vue?vue&type=template&id=70cf26de&"
import script from "./AdminCompany.vue?vue&type=script&lang=ts&"
export * from "./AdminCompany.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCompany.vue?vue&type=style&index=0&id=70cf26de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports